export class LocalStorageService {

  readonly PRIMARY_COLOR_TAG: string = 'primaryColor';
  readonly PRIMARY_TEXT_COLOR_TAG: string = 'primaryTextColor';
  readonly SECONDARY_COLOR_TAG: string = 'secondaryColor';
  readonly SECONDARY_TEXT_COLOR_TAG: string = 'secondaryTextColor';
  readonly TOKEN_TAG: string = 'token';
  readonly CULTURE_TAG: string = 'culture';
  readonly COUNTRY_TAG: string = 'country';
  readonly FONT_TAG: string = 'font';
  readonly TEXT_COLOR_TAG: string = 'textColor';
  readonly TITLE_TEXT_COLOR_TAG: string = 'titleTextColor';
  readonly COMPANY_LOGO_URL_TAG: string = 'companyLogoUrl';
  readonly BACKGROUND_URL_TAG: string = 'backgroundUrl';
  readonly REFRESH_TOKEN_TAG: string = 'refreshToken';
  readonly LOGIN_ID_TAG: string = 'loginId';
  readonly EXPIRE_TAG: string = 'expire';
  readonly FIRST_NAME_TAG: string = 'firstName';
  readonly LAST_NAME_TAG: string = 'lastName';
  readonly EMAIL_TAG: string = 'email';

  public setFirstname(value) {
    localStorage.setItem(this.FIRST_NAME_TAG, value);
  }

  public getFirstname(): string {
    return localStorage.getItem(this.FIRST_NAME_TAG);
  }

  public setLastname(value) {
    localStorage.setItem(this.LAST_NAME_TAG, value);
  }

  public getLastname(): string {
    return localStorage.getItem(this.LAST_NAME_TAG);
  }

  public setEmail(value) {
    localStorage.setItem(this.EMAIL_TAG, value);
  }

  public getEmail(): string {
    return localStorage.getItem(this.EMAIL_TAG);
  }

  public setRefreshToken(value) {
    localStorage.setItem(this.REFRESH_TOKEN_TAG, value);
  }

  public getRefreshToken(): string {
    return localStorage.getItem(this.REFRESH_TOKEN_TAG);
  }

  public setBackgroundUrl(value) {
    localStorage.setItem(this.BACKGROUND_URL_TAG, value);
  }

  public getBackgroundUrl(): string {
    return localStorage.getItem(this.BACKGROUND_URL_TAG);
  }

  public setCompanyLogoUrl(value) {
    localStorage.setItem(this.COMPANY_LOGO_URL_TAG, value);
  }

  public getCompanyLogoUrl(): string {
    return localStorage.getItem(this.COMPANY_LOGO_URL_TAG);
  }

  public setPrimaryColor(value) {
    localStorage.setItem(this.PRIMARY_COLOR_TAG, value);
  }

  public getPrimaryColor(): string {
    return localStorage.getItem(this.PRIMARY_COLOR_TAG);
  }

  public setPrimaryTextColor(value) {
    localStorage.setItem(this.PRIMARY_TEXT_COLOR_TAG, value);
  }

  public getPrimaryTextColor(): string {
    return localStorage.getItem(this.PRIMARY_TEXT_COLOR_TAG);
  }

  public setSecondaryColor(value) {
    localStorage.setItem(this.SECONDARY_COLOR_TAG, value);
  }

  public getSecondaryColor(): string {
    return localStorage.getItem(this.SECONDARY_COLOR_TAG);
  }

  public setSecondaryTextColor(value) {
    localStorage.setItem(this.SECONDARY_TEXT_COLOR_TAG, value);
  }

  public getSecondaryTextColor(): string {
    return localStorage.getItem(this.SECONDARY_TEXT_COLOR_TAG);
  }

  public getFont(): string {
    return localStorage.getItem(this.FONT_TAG);
  }

  public setFont(value) {
    localStorage.setItem(this.FONT_TAG, value);
  }

  public getTextColor(): string {
    return localStorage.getItem(this.TEXT_COLOR_TAG);
  }

  public setTextColor(value) {
    return localStorage.setItem(this.TEXT_COLOR_TAG, value);
  }

  public getTitleTextColor(): string {
    return localStorage.getItem(this.TITLE_TEXT_COLOR_TAG);
  }

  public setTitleTextColor(value) {
    return localStorage.setItem(this.TITLE_TEXT_COLOR_TAG, value);
  }

  public doesTokenExist(): boolean {
    return this.getToken() != null;
  }

  public getToken(): any {
    return localStorage.getItem(this.TOKEN_TAG);
  }

  public setToken(value) {
    localStorage.setItem(this.TOKEN_TAG, value);
  }

  public setCulture(value) {
    localStorage.setItem(this.CULTURE_TAG, value);
  }

  public getCulture(): string {
    return localStorage.getItem(this.CULTURE_TAG);
  }

  public setCountry(value) {
    localStorage.setItem(this.COUNTRY_TAG, value);
  }

  public getCountry(): string {
    return localStorage.getItem(this.COUNTRY_TAG);
  }

  public getLoginId(): string {
    return localStorage.getItem(this.LOGIN_ID_TAG);
  }

  public setLoginId(value) {
    localStorage.setItem(this.LOGIN_ID_TAG, value);
  }

  public setExpire(value) {
    localStorage.setItem(this.EXPIRE_TAG, value);
  }

  public deleteRefreshToken() {
    localStorage.removeItem(this.REFRESH_TOKEN_TAG);
  }

  public deleteToken() {
    localStorage.removeItem(this.TOKEN_TAG);
  }

  public deleteExpire() {
    localStorage.removeItem(this.EXPIRE_TAG);
  }

  public deleteLoginId() {
    localStorage.removeItem(this.LOGIN_ID_TAG);
  }

  public deleteFirstname() {
    localStorage.removeItem(this.FIRST_NAME_TAG);
  }

  public deleteLastname() {
    localStorage.removeItem(this.LAST_NAME_TAG);
  }

  public deleteEmail() {
    localStorage.removeItem(this.EMAIL_TAG);
  }
}
